/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

import { CommentParentType } from '@umu/umu-types';

export interface IInput {
    comment_id: number;
    parent_type?: CommentParentType;
}

export interface IOutput {
    status: number;
    share_pic_url: string;
}

export const getSharePicUrl = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_SHARE_PIC_URL, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
